<button
    type="button"
    class="campaign__action btn btn--paybee btn--outline-transparent"
    placement="bottom"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    #popover="mdbPopover"
>
    <img class='mdb-popover' src="/img/svg/virtual-event/actions.svg"/>
</button>


<ng-template #content >
  <div class="popover-links popover-links--aligned">
    <div
        *ngIf="event.type === 0 || event.type === 2"
        class="popover__action d-flex align-items-center cursor-pointer px-2"
        (click)="onClickReportEvent(event, 0)"
    >
        <i class="far fa-chart-bar mr-2"></i>
        <div>In-Person Event Report...</div>
    </div>
    <div
        *ngIf="event.type === 1 || event.type === 2"
        class="popover__action d-flex align-items-center cursor-pointer px-2"
        (click)="onClickReportEvent(event, 1)"
    >
        <i class="far fa-chart-bar mr-2"></i>
        <div>Virtual Event Report...</div>
    </div>
    <div
        *ngIf="event.type === 0 || event.type === 1"
        class="popover__action d-flex align-items-center cursor-pointer px-2"
        (click)="onClickUpgradeToHybrid(event)"
    >
        <i class="far fa-chart-bar mr-2"></i>
        <div>Upgrade to Hybrid ...</div>
    </div>
    <div
        class="popover__action d-flex align-items-center cursor-pointer px-2"
        (click)="onClickCopyEvent(event)"
    >
        <i class="far fa-clone mr-2"></i>
        <div>Copy</div>
    </div>
    <ng-container
        *ngIf="!isProduction"
    >
        <div
            *ngIf="event.type === 1 || event.type === 2"
            class="popover__action d-flex align-items-center cursor-pointer px-2"
            (click)="onClickResetData(event)"
        >
            <i class="fas fa-eraser mr-2"></i>
            <div>Reset Virtual Event Data</div>
        </div>
    </ng-container>
  </div>
</ng-template>
